var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18.8027V28.3673C7.99999 28.4408 8.01458 28.5135 8.04293 28.5812C8.07127 28.649 8.1128 28.7104 8.1651 28.762C8.2174 28.8135 8.27942 28.8542 8.34757 28.8816C8.41572 28.9089 8.48863 28.9225 8.56206 28.9214H11.0166V31.1327C11.0166 31.1671 11.0269 31.2007 11.046 31.2293C11.0651 31.2579 11.0923 31.2802 11.1241 31.2933C11.1558 31.3065 11.1908 31.3099 11.2245 31.3032C11.2583 31.2965 11.2893 31.28 11.3136 31.2557L13.6494 28.9214H20.03C20.1027 28.9214 20.1747 28.9071 20.2418 28.8792C20.3089 28.8513 20.3699 28.8105 20.4212 28.759C20.4726 28.7076 20.5132 28.6465 20.5409 28.5793C20.5686 28.512 20.5827 28.44 20.5825 28.3673V18.8027C20.5825 18.7087 20.5585 18.6161 20.5128 18.5339C20.4671 18.4517 20.4011 18.3825 20.3211 18.3329C20.2412 18.2833 20.1499 18.255 20.0559 18.2506C19.9619 18.2462 19.8684 18.2659 19.7841 18.3077L14.5387 20.9312C14.4622 20.9698 14.3777 20.9899 14.292 20.9899C14.2063 20.9899 14.1218 20.9698 14.0453 20.9312L8.79838 18.3077C8.71408 18.2663 8.62064 18.247 8.52683 18.2516C8.43302 18.2563 8.34193 18.2846 8.26211 18.3341C8.18228 18.3836 8.11635 18.4526 8.0705 18.5346C8.02465 18.6165 8.00039 18.7088 8 18.8027Z",
    fill: "url(#paint0_linear_2175_22429)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4604 25.4756C12.2861 26.0935 13.2897 26.4275 14.321 26.4275C15.3524 26.4275 16.3559 26.0935 17.1816 25.4756",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2175_22429",
    x1: 12.7758,
    y1: 21.2847,
    x2: 13.7872,
    y2: 28.3646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02ABF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.837a011b3cf75ec181ea2724f16f8f5e.svg";
export { ForwardRef as ReactComponent };